/* =====================================================================
   Esteé Paris — shell JS (Horizon-basis, okt 2026). Eigen code.
   - winkelmand-drawer (#CartDrawer, .js-drawer-open-cart / .js-drawer-close)
   - menu-drawer (#NavDrawer), accordeons, footer-accordeons
   - aankondigingsbalk-rotatie, zoekbalk met suggesties, taal/land-kiezer
   Contract met estee-paris.js + theme.liquid: klasse drawer--is-open,
   event 'ajaxProduct:added', events cart:refresh / cart:updated.
   ===================================================================== */
(function () {
  'use strict';
  var html = document.documentElement;
  var overlay = document.createElement('div');
  overlay.className = 'ep-overlay';
  overlay.setAttribute('aria-hidden', 'true');
  document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(overlay); });
  if (document.body) document.body.appendChild(overlay);

  var openDrawer = null;

  function lock(on) { html.classList.toggle('ep-lock', !!on); }

  function closeAll() {
    var cd = document.getElementById('CartDrawer');
    var nd = document.getElementById('NavDrawer');
    if (cd) cd.classList.remove('drawer--is-open');
    if (nd) { nd.classList.remove('is-open', 'drawer--is-open'); nd.setAttribute('aria-hidden', 'true'); }
    document.querySelectorAll('.js-drawer-open-nav').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    overlay.classList.remove('is-on');
    lock(false);
    openDrawer = null;
  }

  function openCart() {
    var cd = document.getElementById('CartDrawer');
    if (!cd) { window.location = '/cart'; return; }
    if (openDrawer === 'cart') return;
    closeAll();
    cd.classList.add('drawer--is-open');
    overlay.classList.add('is-on');
    lock(true);
    openDrawer = 'cart';
  }

  function openNav() {
    var nd = document.getElementById('NavDrawer');
    if (!nd) return;
    closeAll();
    nd.classList.add('is-open', 'drawer--is-open');
    nd.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('.js-drawer-open-nav').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    overlay.classList.add('is-on');
    lock(true);
    openDrawer = 'nav';
  }

  window.EP_SHELL = { openCart: openCart, openNav: openNav, close: closeAll };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('.js-drawer-open-cart')) {
      if (window.location.pathname.replace(/^\/(es|pt)(?=\/|$)/, '').replace(/\/$/, '') === '/cart') return;
      e.preventDefault(); openCart(); return;
    }
    if (t.closest('.js-drawer-open-nav')) { e.preventDefault(); openNav(); return; }
    if (t.closest('.js-drawer-close')) { e.preventDefault(); closeAll(); return; }
    if (t === overlay) { closeAll(); return; }

    var tog = t.closest('.ep-mnav__toggle');
    if (tog) {
      var sub = document.getElementById(tog.getAttribute('aria-controls'));
      var open = tog.getAttribute('aria-expanded') !== 'true';
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (sub) sub.classList.toggle('is-open', open);
      return;
    }

    var ft = t.closest('[data-ep-ft-toggle]');
    if (ft) {
      var body = ft.nextElementSibling;
      var o = ft.getAttribute('aria-expanded') !== 'true';
      ft.setAttribute('aria-expanded', o ? 'true' : 'false');
      if (body) body.classList.toggle('is-open', o);
      return;
    }

    // taal/land-kiezer
    var dt = t.closest('[data-ep-disclosure-toggle]');
    if (dt) {
      var list = document.getElementById(dt.getAttribute('aria-controls'));
      var isOpen = dt.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('[data-ep-disclosure-toggle][aria-expanded="true"]').forEach(function (x) {
        x.setAttribute('aria-expanded', 'false');
        var l = document.getElementById(x.getAttribute('aria-controls')); if (l) l.hidden = true;
      });
      if (!isOpen && list) { dt.setAttribute('aria-expanded', 'true'); list.hidden = false; }
      return;
    }
    var opt = t.closest('.ep-loc__opt');
    if (opt) {
      e.preventDefault();
      var form = opt.closest('form');
      var inp = form && form.querySelector('input[name="' + opt.getAttribute('data-input') + '"]');
      if (inp) { inp.value = opt.getAttribute('data-value'); form.submit(); }
      return;
    }
    if (!t.closest('[data-ep-disclosure]')) {
      document.querySelectorAll('[data-ep-disclosure-toggle][aria-expanded="true"]').forEach(function (x) {
        x.setAttribute('aria-expanded', 'false');
        var l = document.getElementById(x.getAttribute('aria-controls')); if (l) l.hidden = true;
      });
    }

    // zoekbalk
    if (t.closest('.js-search-header')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-ep-search-close]')) { e.preventDefault(); closeSearch(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); closeSearch(); }
  });

  // bestaande Esteé-code vuurt dit na toevoegen aan mandje
  document.addEventListener('ajaxProduct:added', function () { openCart(); });

  // badge bij cart-wijzigingen bijwerken
  function setBubble(count) {
    document.querySelectorAll('[data-ep-cart-bubble]').forEach(function (b) { b.classList.toggle('is-on', count > 0); });
  }
  function refreshBubble() {
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      setBubble(c.item_count || 0);
      var cd = document.getElementById('CartDrawer');
      if (cd) cd.classList.toggle('is-empty', !(c.item_count > 0));
    }).catch(function () {});
  }
  var _f = window.fetch;
  window.fetch = function () {
    var u = arguments[0];
    var s = typeof u === 'string' ? u : (u && u.url ? u.url : '');
    var p = _f.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(s)) { p.then(function () { setTimeout(refreshBubble, 450); }).catch(function () {}); }
    return p;
  };
  ['cart:updated', 'cart:add'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(refreshBubble, 450); }); });

  // aankondigingsbalk
  function initAnn() {
    var wrap = document.querySelector('[data-ep-ann]');
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.ep-ann__slide');
    if (slides.length < 2) return;
    var i = 0, paused = false;
    wrap.addEventListener('mouseenter', function () { paused = true; });
    wrap.addEventListener('mouseleave', function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 5000);
  }

  // desktop-menu: toetsenbord / touch
  function initNav() {
    document.querySelectorAll('.ep-nav__item--drop').forEach(function (li) {
      li.addEventListener('focusin', function () { li.classList.add('is-open'); });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) li.classList.remove('is-open'); });
      li.addEventListener('mouseleave', function () { li.classList.remove('is-open'); });
    });
  }

  // zoeken
  var searchBox, searchInput, searchRes, searchTimer, searchCtrl;
  function openSearch() {
    searchBox = searchBox || document.querySelector('[data-ep-search]');
    if (!searchBox) { window.location = '/search'; return; }
    searchBox.hidden = false;
    searchInput = searchInput || searchBox.querySelector('[data-ep-search-input]');
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 50);
  }
  function closeSearch() {
    if (searchBox) searchBox.hidden = true;
  }
  function money(cents) {
    var n = Number(cents) / 100;
    try { return n.toLocaleString(html.lang || 'fr', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); } catch (e) { return n.toFixed(2) + ' €'; }
  }
  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function runSearch(q) {
    searchRes = searchRes || searchBox.querySelector('[data-ep-search-results]');
    if (!q || q.length < 2) { searchRes.innerHTML = ''; return; }
    if (searchCtrl && searchCtrl.abort) searchCtrl.abort();
    searchCtrl = window.AbortController ? new AbortController() : null;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    _f(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last', searchCtrl ? { signal: searchCtrl.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!ps.length) { searchRes.innerHTML = ''; return; }
        var h = '<ul class="ep-sr">';
        ps.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
          h += '<li><a href="' + esc(p.url) + '"><div class="ep-sr__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>'
            + '<div class="ep-sr__t">' + esc(p.title) + '</div><div class="ep-sr__p">' + money(Math.round(parseFloat(p.price) * 100)) + '</div></a></li>';
        });
        h += '</ul><a class="ep-sr__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + esc(searchBox.getAttribute('data-all-label') || 'Voir tous les résultats') + ' &rarr;</a>';
        searchRes.innerHTML = h;
      }).catch(function () {});
  }
  function initSearch() {
    searchBox = document.querySelector('[data-ep-search]');
    if (!searchBox) return;
    searchInput = searchBox.querySelector('[data-ep-search-input]');
    if (searchInput) searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      searchTimer = setTimeout(function () { runSearch(q); }, 250);
    });
  }

  function init() {
    initAnn(); initNav(); initSearch();
    var cd = document.getElementById('CartDrawer');
    if (cd && cd.parentNode !== document.body) document.body.appendChild(cd);
    var nd = document.getElementById('NavDrawer');
    if (nd && nd.parentNode !== document.body) document.body.appendChild(nd);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
